export function isDefined(value: any): boolean {
  return value !== undefined && value !== null;
}

export function isObject(value: any): boolean {
  return typeof value === 'object' && isDefined(value);
}

export function isFunction(value: any): boolean {
  return value instanceof Function;
}

export function isPromise(value: any): boolean {
  return value instanceof Promise;
}
